import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './ProjetDetail.css';

function ProjetDetail() {
  const location = useLocation();
  const navigate = useNavigate();

  const project = location.state?.project;

  if (!project) {
    return (
      <div className="projet-detail-container">
        <h1>Projet introuvable</h1>
        <p>
          Les données du projet n'ont pas été trouvées. Cela peut arriver si tu
          as rechargé la page directement.
        </p>
        <button onClick={() => navigate('/projets')} className="back-button">
          Retour aux projets
        </button>
      </div>
    );
  }

  return (
    <div className="projet-detail-container">
      <button onClick={() => navigate('/projets')} className="back-button">
        ← Retour aux projets
      </button>

      <div className="projet-detail-header">
        <h1>{project.titre}</h1>
        <p className="projet-detail-description">{project.description}</p>
      </div>

      {project.images && project.images.length > 0 && (
        <div className="projet-detail-gallery">
          {project.images.map((image, index) => (
            <img
              key={index}
              src={image}
              alt={`${project.titre} - visuel ${index + 1}`}
              className="projet-detail-image"
            />
          ))}
        </div>
      )}

      {project.technologies && (
        <section className="projet-detail-section">
          <h2>Technologies utilisées</h2>
          <div className="projet-detail-tags">
            {project.technologies.map((tech, index) => (
              <span key={index} className="tag">
                {tech}
              </span>
            ))}
          </div>
        </section>
      )}

      {project.contenuDetail?.contexte && (
        <section className="projet-detail-section">
          <h2>Contexte</h2>
          <p>{project.contenuDetail.contexte}</p>
        </section>
      )}

      {project.contenuDetail?.objectifs && (
        <section className="projet-detail-section">
          <h2>Objectifs</h2>
          <ul>
            {project.contenuDetail.objectifs.map((objectif, index) => (
              <li key={index}>{objectif}</li>
            ))}
          </ul>
        </section>
      )}

      {project.contenuDetail?.realisations && (
        <section className="projet-detail-section">
          <h2>Réalisations</h2>
          <ul>
            {project.contenuDetail.realisations.map((realisation, index) => (
              <li key={index}>{realisation}</li>
            ))}
          </ul>
        </section>
      )}

      {project.apports && (
        <section className="projet-detail-section">
          <h2>Apports du projet</h2>
          <ul>
            {project.apports.map((apport, index) => (
              <li key={index}>{apport}</li>
            ))}
          </ul>
        </section>
      )}

      {project.contenuDetail?.difficultes && (
        <section className="projet-detail-section">
          <h2>Difficultés rencontrées</h2>
          <p>{project.contenuDetail.difficultes}</p>
        </section>
      )}

      {project.contenuDetail?.resultat && (
        <section className="projet-detail-section">
          <h2>Résultat / bilan</h2>
          <p>{project.contenuDetail.resultat}</p>
        </section>
      )}

      {project.contenuDetail?.competences && (
        <section className="projet-detail-section">
          <h2>Compétences développées</h2>
          <div className="projet-detail-tags">
            {project.contenuDetail.competences.map((competence, index) => (
              <span key={index} className="tag">
                {competence}
              </span>
            ))}
          </div>
        </section>
      )}
    </div>
  );
}

export default ProjetDetail;